import React, { useState, useEffect, useCallback } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import {
  Wifi, Beaker, Users, Monitor, Shield, Droplets, Leaf, Smile, Clock,
  TrendingUp, Cpu, Zap, Award, Link2, Star, Crown, CheckCircle2, Check,
  Wrench, Settings, Handshake, Mail, Cloud, Target, Eye, Heart,
} from 'lucide-react';
import './Home.css';
import {
  Reveal, Stagger, StaggerItem, Parallax, motion, AnimatePresence,
} from '../components/motion/Motion';
import imgCarousel1 from '../assets/images/Imagem21-3.jpg';
import imgCarousel2 from '../assets/images/Imagem11-2.jpg';
import imgCarousel3 from '../assets/images/Imagem12-2.jpg';
import imgCarousel4 from '../assets/images/Imagem19-2.jpg';
import imgCarousel5 from '../assets/images/Imagem14-2.jpg';
import imgCarousel6 from '../assets/images/Imagem15-2.jpg';
import imgCarousel7 from '../assets/images/Imagem16-2.jpg';
import imgCarousel8 from '../assets/images/Imagem17-2.jpg';
import imgCarousel9 from '../assets/images/Imagem18-2.jpg';
import imgCarousel10 from '../assets/images/Imagem20-2.jpg';
import wepikImg from '../assets/images/wepik-export-20240327221844XfJe-1024x683.png';
import whatsappImg from '../assets/images/WhatsApp-Image-2024-04-17-at-21.41.04.jpeg';

const CAROUSEL_IMAGES = [
  imgCarousel1,
  imgCarousel2,
  imgCarousel3,
  imgCarousel4,
  imgCarousel5,
  imgCarousel6,
  imgCarousel7,
  imgCarousel8,
  imgCarousel9,
  imgCarousel10,
];

const SLIDE_MS = 5000;

const WA_ICON = (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const WA_ICON_LG = (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const CopyButton = ({ value }) => {
  const [copied, setCopied] = useState(false);

  const handle = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
  };

  useEffect(() => {
    if (!copied) return undefined;
    const t = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(t);
  }, [copied]);

  return (
    <button
      type="button"
      className={`copy-btn${copied ? ' is-done' : ''}`}
      onClick={handle}
      title="Copiar"
    >
      {copied ? (
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
      ) : (
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" /><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" /></svg>
      )}
    </button>
  );
};

/* Marca inline. Aparece dezenas de vezes no meio das frases; centralizar aqui
   evita repetir os dois spans e garante a mesma cor em todo lugar. */
const Brand = () => (
  <><span className="brand-ipool">iPool</span><span className="brand-care">Care</span></>
);

/**
 * Casa de máquinas: casinha com engrenagem, como na arte original do
 * Ativo-4.png. O lucide não tem essa combinação, então é desenhada aqui no
 * mesmo padrão dos demais ícones (viewBox 24, traço, pontas arredondadas).
 */
const IconCasaMaquinas = ({ size = 30 }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M3 10.6 12 3.2l9 7.4V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z" />
    <circle cx="12" cy="14.6" r="2" />
    <path d="M12 12.1v-1M12 17.1v1M14.5 14.6h1M8.5 14.6h-1M13.77 12.83l.7-.7M10.23 16.37l-.7.7M13.77 16.37l.7.7M10.23 12.83l-.7-.7" />
  </svg>
);

/**
 * As duas soluções, agora em abas em vez de dois cards lado a lado com um
 * "OU" no meio. O rótulo de cada aba é o próprio badge que antes ficava dentro
 * do card, então nenhum texto foi duplicado nem inventado.
 */
const SOLUCOES = [
  {
    id: 'rti',
    badge: 'INTEGRAÇÃO RTI',
    icon: <Link2 size={30} />,
    titulo: <>RTI <Brand /></>,
    tagline: 'Para quem já tem automação e quer supervisão profissional.',
    itens: [
      <><strong>Integração com automação existente</strong> — compatível com diversas marcas</>,
      <><strong>Supervisão química profissional</strong> + Sensei com visitas mensais</>,
      <><strong>Monitoramento remoto</strong>, relatórios NBR/ABNT, link exclusivo para usuários</>,
      <><strong>Treinamento Ninja</strong> + alertas antecipados de problemas</>,
      <><strong>Emissão de ART</strong></>,
    ],
    banner: 'Supervisão profissional. Segurança jurídica.',
  },
  {
    id: 'completo',
    badge: 'SOLUÇÃO COMPLETA',
    icon: <Award size={30} />,
    titulo: <>Sistema <Brand /> Completo</>,
    tagline: 'Para quem quer a solução total — sem preocupações.',
    itens: [
      <><strong>Automação <Brand /> exclusiva</strong> — sensores e controladores próprios instalados</>,
      <><strong>Dosagem química com máxima precisão</strong> — garantida pelo sistema proprietário</>,
      <><strong>Monitoramento remoto 24h/7</strong> + Sensei + Ninjas treinados</>,
      <><strong>Manutenção dos equipamentos incluída</strong></>,
      <><strong>Acompanhamento por químico responsável</strong> + emissão de ART</>,
    ],
    banner: 'Qualidade garantida. Resultado previsível.',
  },
];

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [solucaoAtiva, setSolucaoAtiva] = useState(SOLUCOES[0].id);
  const solAtual = SOLUCOES.find((s) => s.id === solucaoAtiva) ?? SOLUCOES[0];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % CAROUSEL_IMAGES.length);
    }, SLIDE_MS);
    return () => clearInterval(timer);
  }, []);

  const goToSlide = useCallback((index) => setCurrentSlide(index), []);

  return (
    <div className="home-page">
      <Header />

      {/* ─── Hero ─────────────────────────────────────────────────────────── */}
      <section id="inicio" className="hero">
        <div className="hero__media" aria-hidden="true">
          {CAROUSEL_IMAGES.map((img, index) => (
            <motion.div
              key={index}
              className="hero__slide"
              style={{ backgroundImage: `url(${img})` }}
              initial={false}
              animate={{
                opacity: index === currentSlide ? 1 : 0,
                scale: index === currentSlide ? 1.08 : 1,
              }}
              transition={{
                opacity: { duration: 1.2, ease: 'easeInOut' },
                scale: { duration: SLIDE_MS / 1000 + 1.2, ease: 'linear' },
              }}
            />
          ))}
        </div>

        <div className="hero__scrim" aria-hidden="true" />

        <div className="hero__content">
          <div className="hero-ticker">
            <div className="hero-ticker__track">
              {[...Array(6)].map((_, i) => (
                <span key={i} className="hero-ticker__item" aria-hidden={i > 0}>
                  <Brand />&nbsp;de olho na piscina. Cuidando de você.
                  <span className="hero-ticker__dot">·</span>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="hero__dots">
          {CAROUSEL_IMAGES.map((_, index) => (
            <button
              key={index}
              type="button"
              className={`hero-dot${index === currentSlide ? ' is-active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            >
              <span className="hero-dot__bar">
                <span className="hero-dot__fill" />
              </span>
            </button>
          ))}
        </div>

        {/* Indicador de rolagem — puramente gráfico, sem texto. */}
        <div className="hero__cue" aria-hidden="true"><span /></div>
      </section>

      {/* ─── Problemas ────────────────────────────────────────────────────── */}
      <section className="section problems">
        <div className="container problems__grid">
          <Reveal from="right" className="problems__text">
            <h2 className="problems__title">
              SABE TODOS AQUELES PROBLEMAS QUE ADMINISTRAR UMA PISCINA TRAZ?
            </h2>
            <p className="problems__lead">
              Administrar uma piscina envolve uma série de desafios que vão além do
              simples cuidado com a água. É necessário um planejamento eficiente,
              conhecimento técnico e uma gestão atenta para garantir que a piscina
              permaneça um local de lazer seguro e saudável.
            </p>
          </Reveal>

          <Reveal from="left" delay={0.1} className="problems__media">
            <Parallax distance={40}>
              <img
                src={wepikImg}
                alt="Pessoa preocupada"
                width={1024}
                height={683}
                loading="lazy"
                decoding="async"
              />
            </Parallax>
          </Reveal>
        </div>
      </section>

      {/* ─── Pilares ──────────────────────────────────────────────────────── */}
      <section id="pilares" className="section section--deep pilares">
        <div className="pilares__aura" aria-hidden="true" />

        <div className="container">
          <Reveal className="section-head section-head--center">
            <span className="kicker">A BASE DO NOSSO MÉTODO</span>
            <h2 className="section-title">Os 4 Pilares</h2>
          </Reveal>

          <Stagger className="pilares__grid" gap={0.1}>
            {[
              {
                icon: <Wifi size={30} />,
                title: <>IoT &amp; Monitoramento</>,
                text: 'Sensores de pH, ORP e temperatura com leituras contínuas 24/7. O sistema analisa os dados e age automaticamente.',
              },
              {
                icon: <Beaker size={30} />,
                title: 'Automação Química',
                text: 'Dosagem automática do mínimo necessário de produtos químicos — sem excessos, sem desperdício, sem risco.',
              },
              {
                icon: <Users size={30} />,
                title: 'Sensei + Ninja',
                text: 'Químico responsável com supervisão e ART, junto a equipe treinada para os cuidados estéticos diários — segurança e praticidade com procedimentos técnicos padrão.',
              },
              {
                icon: <Monitor size={30} />,
                title: 'Visualização em tempo real',
                text: 'Banhistas e administradores têm acesso direto de qualquer lugar remoto, além de monitores na área da piscina.',
              },
            ].map((pilar, i) => (
              <StaggerItem key={i} className="pilar-card">
                <div className="pilar-card__icon">{pilar.icon}</div>
                <h3>{pilar.title}</h3>
                <p>{pilar.text}</p>
              </StaggerItem>
            ))}
          </Stagger>

          <Reveal delay={0.15}>
            <p className="pilares__closing">
              Quatro pilares que trabalham juntos, ininterruptamente, 24h por dia,
              7 dias por semana.
            </p>
          </Reveal>
        </div>
      </section>

      {/* ─── Vantagens ────────────────────────────────────────────────────── */}
      <section id="vantagens" className="section vantagens">
        <div className="container">
          <Reveal className="section-head section-head--center">
            <h2 className="section-title">VANTAGENS PARA OS ADMINISTRADORES</h2>
          </Reveal>

          <Stagger className="vantagens__grid" gap={0.08}>
            <StaggerItem className="vantagem-card">
              <div className="card-icon"><Shield size={26} /></div>
              <h3>Prevenção</h3>
              <ul>
                <li>Alertas automáticos sobre problemas.</li>
                <li>Menor risco de exposição à Vigilância Sanitária e de passivos trabalhistas.</li>
              </ul>
            </StaggerItem>

            <StaggerItem className="vantagem-card">
              <div className="card-icon"><Leaf size={26} /></div>
              <h3>Sustentabilidade</h3>
              <ul>
                <li>Menor troca da água.</li>
                <li>Redução do uso das bombas.</li>
              </ul>
            </StaggerItem>

            {/* Card em destaque: ocupa o centro do bento e usa o acento quente. */}
            <StaggerItem className="vantagem-card vantagem-card--highlight on-color">
              <div className="card-icon"><Smile size={26} /></div>
              <h3>Paz de Espírito</h3>
              <p className="vantagem-card__sub">Só com a <Brand />.</p>
            </StaggerItem>

            <StaggerItem className="vantagem-card">
              <div className="card-icon"><Smile size={26} /></div>
              <h3>Satisfação do usuário</h3>
              <ul>
                <li>Usuário mais satisfeito.</li>
                <li>Menos reclamações.</li>
                <li>Superação das expectativas dos banhistas.</li>
              </ul>
            </StaggerItem>

            <StaggerItem className="vantagem-card">
              <div className="card-icon"><Clock size={26} /></div>
              <h3>Praticidade</h3>
              <ul>
                <li>Gestão e manutenção da automação.</li>
                <li>Controle de parâmetros com garantia da qualidade da água.</li>
                <li>Relatórios automáticos e acompanhamento em tempo real.</li>
              </ul>
            </StaggerItem>
          </Stagger>
        </div>
      </section>

      {/* ─── Benefícios ───────────────────────────────────────────────────── */}
      <section className="section beneficios">
        <div className="container">
          <Reveal className="section-head section-head--center">
            <h2 className="section-title">Benefícios para os usuários</h2>
          </Reveal>

          <Stagger className="beneficios__grid" gap={0.07}>
            {[
              { icon: <Shield size={24} />, text: 'Liberdade para todos nadarem na água sem risco de contaminações.' },
              { icon: <Droplets size={24} />, text: 'Sem excesso de produtos químicos. Mergulho liberado!' },
              { icon: <Clock size={24} />, text: 'Maior disponibilidade da piscina. Água boa o tempo todo.' },
              { icon: <Leaf size={24} />, text: 'Sem o mau cheiro da cloramina.' },
              { icon: <TrendingUp size={24} />, text: 'Conhecimento da temperatura e da qualidade da água, antes mesmo de entrar nela.' },
              { icon: <Smile size={24} />, text: 'Sem cabelos ressecados e sem pele coçando.' },
            ].map((item, i) => (
              <StaggerItem key={i} className="beneficio-item">
                <div className="beneficio-item__icon">{item.icon}</div>
                <p>{item.text}</p>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      {/* ─── Tecnologia ───────────────────────────────────────────────────── */}
      <section id="tecnologia" className="section section--deep tecnologia">
        <div className="tecnologia__aura" aria-hidden="true" />

        <div className="container">
          <Reveal className="section-head section-head--center">
            <h2 className="section-title">A Tecnologia <Brand /></h2>
            <p className="section-lead">
              Desenvolvida inteiramente por nós para garantir um{' '}
              <strong>tratamento infalível</strong> da água da sua piscina.
            </p>
          </Reveal>

          {/* Substitui a imagem Ativo-4.png: mesmos três nós e os mesmos
              rótulos, agora em ícone + texto, com o fluxo animado entre eles. */}
          <Reveal from="none" scale={0.94} delay={0.1} className="tecnologia__flow">
            <div className="flow-node">
              <div className="flow-node__icon"><IconCasaMaquinas size={30} /></div>
              <span className="flow-node__label">Casa de Máquinas</span>
            </div>

            <div className="flow-link">
              <span className="flow-link__text">
                Sensores dentro da casa de máquinas comunicam com a nuvem
              </span>
              <span className="flow-link__dot" aria-hidden="true" />
            </div>

            <div className="flow-node flow-node--hub">
              <div className="flow-node__icon"><Cloud size={30} /></div>
              <span className="flow-node__label">Nuvem</span>
            </div>

            <div className="flow-link">
              <span className="flow-link__text">
                Nuvem podem ser acessada pelos usuários e administradores na Web.
              </span>
              <span className="flow-link__dot" aria-hidden="true" />
            </div>

            <div className="flow-node">
              <div className="flow-node__icon"><Monitor size={30} /></div>
              <span className="flow-node__label">Usuário</span>
            </div>
          </Reveal>

          <Stagger className="tecnologia__features" gap={0.09}>
            {[
              {
                icon: <Cpu size={22} />,
                title: <>Hardware &amp; Software exclusivos</>,
                text: 'Tecnologia proprietária desenvolvida do zero para máxima performance e confiabilidade.',
              },
              {
                icon: <Wifi size={22} />,
                title: 'IoT – Monitoramento contínuo 24h/7',
                text: 'Sensores de pH, ORP e temperatura com leituras ininterruptas e ação automática.',
              },
              {
                icon: <Monitor size={22} />,
                title: 'Controle remoto total',
                text: 'Plataforma de monitoramento acessível de qualquer lugar, a qualquer hora.',
              },
              {
                icon: <Zap size={22} />,
                title: 'Comunicação em tempo real',
                text: 'Eficiência e precisão garantidas em todo o processo de tratamento da água.',
              },
            ].map((feat, i) => (
              <StaggerItem key={i} className="tech-feature">
                <div className="tech-feature__icon">{feat.icon}</div>
                <div className="tech-feature__body">
                  <h4>{feat.title}</h4>
                  <p>{feat.text}</p>
                </div>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      {/* ─── Soluções / RTI ───────────────────────────────────────────────── */}
      <section id="nossas-solucoes" className="section section--sunk solucoes">
        <div className="container">
          <Reveal className="section-head section-head--center">
            <h2 className="section-title">
              AS SOLUÇÕES <span className="brand-ipool">IPOOL</span><span className="brand-care">CARE</span>
            </h2>
            <h3 className="solucoes__subtitle">
              Duas formas de cuidar da sua piscina.<br />Um único padrão de excelência.
            </h3>
            <p className="section-lead">
              Cada estabelecimento tem uma realidade diferente. Temos uma solução
              para cada uma.
            </p>
          </Reveal>

          <Reveal className="sol-tabs">
            <div className="sol-tabs__bar" role="tablist">
              {SOLUCOES.map((sol) => (
                <button
                  key={sol.id}
                  type="button"
                  role="tab"
                  id={`tab-${sol.id}`}
                  aria-selected={solucaoAtiva === sol.id}
                  aria-controls={`painel-${sol.id}`}
                  className={`sol-tab${solucaoAtiva === sol.id ? ' is-active' : ''}`}
                  onClick={() => setSolucaoAtiva(sol.id)}
                >
                  {solucaoAtiva === sol.id && (
                    <motion.span
                      className="sol-tab__pill"
                      layoutId="sol-tab-pill"
                      transition={{ type: 'spring', stiffness: 340, damping: 32 }}
                    />
                  )}
                  <span className="sol-tab__icon">{sol.icon}</span>
                  <span className="sol-tab__label">{sol.badge}</span>
                </button>
              ))}
            </div>

            {/* mode="wait" exige UM filho, não um array: com `.filter().map()`
                o ciclo saída→entrada travava e o painel nunca trocava. */}
            <AnimatePresence mode="wait">
              <motion.div
                key={solAtual.id}
                id={`painel-${solAtual.id}`}
                role="tabpanel"
                aria-labelledby={`tab-${solAtual.id}`}
                className={`sol-panel sol-panel--${solAtual.id}`}
                initial={{ opacity: 0, y: 14 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -14 }}
                transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
              >
                <div className="sol-panel__aside on-color">
                  <div className="sol-panel__icon">{solAtual.icon}</div>
                  <h3>{solAtual.titulo}</h3>
                  <p className="sol-panel__tagline">{solAtual.tagline}</p>
                  <div className="sol-panel__banner">{solAtual.banner}</div>
                </div>

                <ul className="sol-features">
                  {solAtual.itens.map((item, i) => (
                    <motion.li
                      key={i}
                      initial={{ opacity: 0, x: 16 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.08 + i * 0.06, duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                    >
                      <span className="sol-check" aria-hidden="true">
                        <Check size={15} strokeWidth={3} />
                      </span>
                      <span>{item}</span>
                    </motion.li>
                  ))}
                </ul>
              </motion.div>
            </AnimatePresence>
          </Reveal>

          {/* ─── Planos RTI ─────────────────────────────────────────────── */}
          <div className="planos">
            <Reveal className="section-head section-head--center">
              <span className="kicker">ESCOLHA O MELHOR PARA VOCÊ</span>
              <h2 className="section-title">Nossos Planos RTI</h2>
              <p className="section-lead">
                Orçamento personalizado sob consulta. Cada estabelecimento é único.
              </p>
            </Reveal>

            <Stagger className="planos__grid" gap={0.12}>
              <StaggerItem className="plano-card plano-card--essencial on-color">
                <div className="plano-card__icon"><Link2 size={26} /></div>
                <h3>Essencial</h3>
                <p>A solução RTI para começar</p>
              </StaggerItem>

              <StaggerItem className="plano-card plano-card--avancado on-color">
                <div className="plano-card__icon"><Star size={26} /></div>
                <h3>Avançado</h3>
                <p>RTI para necessidades específicas</p>
              </StaggerItem>

              <StaggerItem className="plano-card plano-card--premium on-color">
                <div className="plano-card__icon"><Crown size={26} /></div>
                <h3>Premium</h3>
                <p>A experiência RTI máxima</p>
              </StaggerItem>
            </Stagger>

            {/* ─── Requisitos ───────────────────────────────────────────── */}
            <Reveal className="requisitos">
              <h3 className="requisitos__title">Requisitos para adesão</h3>

              <div className="requisitos__grid">
                <div className="requisito-col">
                  <div className="requisito-col__icon"><Wrench size={20} /></div>
                  <h4>ESTRUTURA TÉCNICA</h4>
                  <ul>
                    <li><CheckCircle2 size={14} /><span>Casa de máquinas adequada</span></li>
                    <li><CheckCircle2 size={14} /><span>Sistema de filtração funcional</span></li>
                    <li><CheckCircle2 size={14} /><span>Automação básica de dosagem</span></li>
                  </ul>
                </div>

                <div className="requisito-col">
                  <div className="requisito-col__icon"><Settings size={20} /></div>
                  <h4>CONDIÇÕES OPERACIONAIS</h4>
                  <ul>
                    <li><CheckCircle2 size={14} /><span>Reposição adequada de água</span></li>
                    <li><CheckCircle2 size={14} /><span>Manutenção preventiva</span></li>
                    <li><CheckCircle2 size={14} /><span>Colaborador responsável</span></li>
                  </ul>
                </div>

                <div className="requisito-col">
                  <div className="requisito-col__icon"><Handshake size={20} /></div>
                  <h4>COMPROMISSO</h4>
                  <ul>
                    <li><CheckCircle2 size={14} /><span>Cumprimento de protocolos</span></li>
                    <li><CheckCircle2 size={14} /><span>Permissão para auditorias</span></li>
                  </ul>
                </div>
              </div>
            </Reveal>
          </div>

          {/* ─── CTA da seção ───────────────────────────────────────────── */}
          <Reveal from="none" scale={0.94} className="solucoes__cta on-color">
            <svg className="solucoes__cta-art" viewBox="0 0 160 130" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <rect x="8" y="38" width="144" height="84" rx="12" fill="rgba(255,255,255,0.12)" stroke="rgba(255,255,255,0.4)" strokeWidth="2.5" />
              <rect x="8" y="55" width="144" height="67" fill="rgba(100,200,255,0.22)" />
              <path d="M8 70 C28 62 48 78 68 70 C88 62 108 78 128 70 C138 66 148 70 152 70 L152 80 C138 80 128 84 108 80 C88 76 68 84 48 80 C28 76 18 82 8 80 Z" fill="rgba(255,255,255,0.2)" />
              <path d="M8 90 C30 83 50 97 70 90 C90 83 110 97 130 90 C142 86 150 90 152 90 L152 98 C140 98 130 102 110 98 C90 94 70 102 50 98 C30 94 18 100 8 98 Z" fill="rgba(255,255,255,0.13)" />
              <rect x="44" y="8" width="5" height="82" rx="2.5" fill="rgba(255,255,255,0.6)" stroke="rgba(255,255,255,0.35)" strokeWidth="1" />
              <rect x="68" y="8" width="5" height="82" rx="2.5" fill="rgba(255,255,255,0.6)" stroke="rgba(255,255,255,0.35)" strokeWidth="1" />
              <rect x="44" y="22" width="29" height="5" rx="2.5" fill="rgba(255,255,255,0.85)" />
              <rect x="44" y="38" width="29" height="5" rx="2.5" fill="rgba(255,255,255,0.85)" />
              <rect x="44" y="54" width="29" height="5" rx="2.5" fill="rgba(255,255,255,0.85)" />
              <rect x="44" y="70" width="29" height="5" rx="2.5" fill="rgba(255,255,255,0.85)" />
              <path d="M30 10 C30 6 38 4 46.5 4 C55 4 70 4 72.5 4 C80 4 88 6 88 10" stroke="rgba(255,255,255,0.7)" strokeWidth="4.5" strokeLinecap="round" fill="none" />
              <circle cx="100" cy="100" r="4" fill="rgba(255,255,255,0.2)" stroke="rgba(255,255,255,0.4)" strokeWidth="1.2" />
              <circle cx="115" cy="88" r="2.5" fill="rgba(255,255,255,0.15)" stroke="rgba(255,255,255,0.35)" strokeWidth="1" />
              <circle cx="126" cy="105" r="3" fill="rgba(255,255,255,0.18)" stroke="rgba(255,255,255,0.35)" strokeWidth="1" />
            </svg>

            <h3>Pronto para escolher a melhor solução?</h3>
            <a
              href="https://api.whatsapp.com/send?phone=5511982922298"
              className="btn btn--lg solucoes__cta-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Fale Conosco
            </a>
          </Reveal>
        </div>
      </section>

      {/* ─── Depoimentos ──────────────────────────────────────────────────── */}
      <section id="depoimentos" className="section depoimentos">
        <div className="container">
          <Reveal className="section-head section-head--center">
            <h2 className="section-title">Depoimentos de nossos clientes</h2>
          </Reveal>

          <Stagger className="depoimentos__grid" gap={0.08}>
            <StaggerItem className="depoimento-card">
              <p>"Agora eu entro na água para dar aula e sinto uma grande diferença em relação às outras piscinas onde sou professor. É muito bom poder ver como está a água aqui na TV."</p>
              <div className="depoimento-card__author">Prof. de natação do Clube do Plaza Mayor Ipiranga</div>
            </StaggerItem>

            <StaggerItem className="depoimento-card">
              <p>"Todos estão comentando como está linda a piscina coberta. Desde que a <Brand /> esta aqui, nunca mais tivemos problemas."</p>
              <div className="depoimento-card__author">Ninja da piscina do Clube Itahye</div>
            </StaggerItem>

            <StaggerItem className="depoimento-card">
              <p>Eu nunca mais me preocupei com a piscina e ainda a <Brand /> me avisa antes de acontecer um problema... Foi assim com o aquecedor da interna e com a bomba da piscina grande.</p>
              <div className="depoimento-card__author">Gestor do Boulevard Tamboré</div>
            </StaggerItem>

            <StaggerItem className="depoimento-card">
              <p>"Antes tinha um cheiro estranho na piscina, eu não deixava o meu filho ficar muito tempo, senão ele ficava com coceira e cheiro de cloro. Agora está ótima, estamos muito satisfeitos!"</p>
              <div className="depoimento-card__author">Morador do Clima Mascote</div>
            </StaggerItem>

            <StaggerItem className="depoimento-card">
              <p>"Depois da <Brand /> reduzimos o consumo de água e de energia e zeramos as reclamações dos moradores em relação à qualidade da água."</p>
              <div className="depoimento-card__author">Gestor do Praça das Águas</div>
            </StaggerItem>

            <StaggerItem className="depoimento-card">
              <p>"Antes chegamos a usar três empresas ao mesmo tempo para tratar a nossa piscina, que é a nossa "cereja do bolo"... A <Brand /> sozinha resolveu todas as nossas ofensivas em relação a piscina, agora ela é um orgulho nosso."</p>
              <div className="depoimento-card__author">Diretor do Hilton Morumbi</div>
            </StaggerItem>
          </Stagger>
        </div>
      </section>

      {/* ─── Nós ──────────────────────────────────────────────────────────── */}
      <section id="nos" className="section section--sunk sobre">
        <div className="container sobre__grid">
          <Reveal from="right" className="sobre__media">
            <Parallax distance={50}>
              <img
                src={whatsappImg}
                alt="Equipe iPoolCare"
                width={960}
                height={1280}
                loading="lazy"
                decoding="async"
              />
            </Parallax>
          </Reveal>

          <Reveal from="left" delay={0.1} className="sobre__text">
            <h2 className="sobre__eyebrow">Nós</h2>
            <h3 className="sobre__title">
              Conheça a <Brand />: uma inovação em tratamento de águas de piscinas
            </h3>
            <p>A <Brand /> emergiu em 2019 como uma inovação destinada a repensar o tratamento de piscinas. Com o poder da tecnologia IoT, nossa plataforma mergulha na água e oferece uma gestão de piscinas inteligente, intuitiva e livre de preocupações para todos os amantes da água.</p>
            <p>Esqueça o ditado "O que os olhos não veem, o coração não sente". Anos de experiência nos mostraram que há muito mais sob a superfície da água do que as pessoas imaginam e acreditamos no poder dos dados para manter cada piscina sob nosso cuidado límpida e saudável. Meticulosa observação e pesquisa nos ensinaram que equilibrar a química da piscina é essencial, mas não precisa ser uma tarefa complicada e com desperdícios.</p>
            <p>Nossa tecnologia IoT atua como os olhos e o cérebro da piscina, monitorando continuamente a qualidade da água e ajustando-se automaticamente para manter tudo em harmonia. Fornecemos informações detalhadas e acessíveis para os administradores e usuários, garantindo que todos os banhistas desfrutem de uma água impecável a qualquer hora.</p>
            <p>A <Brand /> está aqui para elevar o tratamento de piscinas a um novo nível de clareza e facilidade.</p>
            <h4 className="sobre__closing">Pronto para um mergulho na era da tecnologia inteligente?</h4>
          </Reveal>
        </div>
      </section>

      {/* ─── Missão, Visão e Valores ──────────────────────────────────────── */}
      <section id="missao" className="section mvv">
        <div className="container">
          <Reveal className="section-head section-head--center">
            <span className="kicker">NOSSA ESSÊNCIA</span>
            <h2 className="section-title">Missão, Visão e Valores</h2>
          </Reveal>

          {/* Assimétrico de propósito: Missão tem 1 item, Visão 3 e Valores 6.
              Em três cards iguais a diferença de altura ficava evidente. */}
          <div className="mvv__layout">
            <Reveal className="mvv-lead">
              <div className="mvv-lead__icon"><Target size={26} /></div>
              <div className="mvv-lead__body">
                <h3>Missão</h3>
                <ul>
                  <li>Ser o maior e melhor sistema de controle e monitoramento de qualidade de águas do mercado.</li>
                </ul>
              </div>
            </Reveal>

            <div className="mvv__pair">
              <Reveal from="right" className="mvv-block">
                <div className="mvv-block__icon"><Eye size={24} /></div>
                <h3>Visão</h3>
                <ul>
                  <li>Entregar aos usuários a certeza de uma água segura, aos administradores a paz de espírito em saber sobre os aspectos da água o tempo todo, aos parceiros um método infalível de tratamento de águas e ao meio ambiente sustentabilidade;</li>
                  <li>Agregar valor para o cliente e para empresa;</li>
                  <li>Transformar a cultura de percepção da qualidade da água.</li>
                </ul>
              </Reveal>

              <Reveal from="left" delay={0.1} className="mvv-block">
                <div className="mvv-block__icon"><Heart size={24} /></div>
                <h3>Valores</h3>
                <ul>
                  <li>Promessa feita, promessa cumprida;</li>
                  <li>Otimismo;</li>
                  <li>Transparência e confiança;</li>
                  <li>Aprendizado, melhoria e crescimento contínuos (bola de neve positiva!);</li>
                  <li>Relações ganha-ganha;</li>
                  <li>Respeito à vida, às pessoas, ao meio ambiente.</li>
                </ul>
              </Reveal>
            </div>
          </div>
        </div>
      </section>

      {/* ─── Contato + rodapé ─────────────────────────────────────────────
          Envolvidos por um bloco único: o gradiente fica neste wrapper e corre
          sem emenda do "Fale Conosco" até o fim do rodapé. */}
      <div className="closing-block">
      <section id="contato" className="section section--deep contato">
        <div className="contato__aura" aria-hidden="true" />

        <div className="container">
          <Reveal className="section-head section-head--center">
            <span className="kicker">CONTATO</span>
            <h2 className="section-title">Fale Conosco</h2>
            <div className="section-lead">
              <p>Estamos aqui para ajudar e responder a todas as suas perguntas! Se você precisar de assistência, informação adicional ou apenas quiser dizer &quot;oi&quot;, não hesite em entrar em contato conosco.</p>
              <p>Ficaremos felizes em ouvir de você e responderemos o mais rápido possível. Aguardamos ansiosamente sua mensagem!</p>
            </div>
          </Reveal>

          <Stagger className="contato__grid" gap={0.12}>
            <StaggerItem className="contato-card">
              <div className="contato-card__icon"><Mail size={22} /></div>
              <h3>Email</h3>
              <p>Prefere contatar-nos por e-mail? Estamos à disposição! Basta enviar uma mensagem para qualquer um dos endereços abaixo, e teremos o prazer de ajudar em tudo o que precisar. Por favor, note que nosso prazo de resposta por e-mail pode ser de até 2 dias úteis.</p>
              <div className="contato-card__list">
                <div className="contato-item">
                  <a href="mailto:fabiola@ipoolcare.com"><Mail size={14} />fabiola@ipoolcare.com</a>
                  <CopyButton value="fabiola@ipoolcare.com" />
                </div>
                <div className="contato-item">
                  <a href="mailto:mauro@ipoolcare.com"><Mail size={14} />mauro@ipoolcare.com</a>
                  <CopyButton value="mauro@ipoolcare.com" />
                </div>
              </div>
            </StaggerItem>

            <StaggerItem className="contato-card contato-card--whatsapp">
              <div className="contato-card__icon">{WA_ICON_LG}</div>
              <h3>WhatsApp</h3>
              <p>Prefere entrar em contato por WhatsApp? Sem problemas! Basta clicar no link abaixo e nos enviar uma mensagem, estamos totalmente à disposição para ajudar.</p>
              <div className="contato-card__list">
                <div className="contato-item">
                  <a href="https://api.whatsapp.com/send?phone=5511982922298" target="_blank" rel="noopener noreferrer">{WA_ICON}(11) 98292-2298</a>
                  <CopyButton value="(11) 98292-2298" />
                </div>
                <div className="contato-item">
                  <a href="https://api.whatsapp.com/send?phone=5511982770880" target="_blank" rel="noopener noreferrer">{WA_ICON}(11) 98277-0880</a>
                  <CopyButton value="(11) 98277-0880" />
                </div>
              </div>
            </StaggerItem>
          </Stagger>

          <Reveal from="none" scale={0.94} className="contato__cta">
            <a
              href="https://api.whatsapp.com/send?phone=5511982922298"
              className="btn btn--flame btn--lg"
              target="_blank"
              rel="noopener noreferrer"
            >
              {WA_ICON_LG}
              Iniciar conversa no WhatsApp
            </a>
          </Reveal>
        </div>
      </section>

        <Footer />
      </div>
    </div>
  );
};

export default Home;
